;
export var NoteCreatorType;
(function (NoteCreatorType) {
    NoteCreatorType["CLIENT"] = "Customer";
    NoteCreatorType["STAFF"] = "Staff";
})(NoteCreatorType || (NoteCreatorType = {}));
